"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePropsContext = exports.PropsContext = void 0;
var react_1 = __importStar(require("react"));
exports.PropsContext = (0, react_1.createContext)({});
var usePropsContext = function () { return (0, react_1.useContext)(exports.PropsContext); };
exports.usePropsContext = usePropsContext;
var PropsProvider = function (_a) {
    var children = _a.children, translate = _a.translate, isMobileHeader = _a.isMobileHeader, isMobileBody = _a.isMobileBody, filter = _a.filter, title = _a.title, actionsElement = _a.actionsElement, onSaveColumnsSettings = _a.onSaveColumnsSettings, isColumnSettings = _a.isColumnSettings, isFlexibleColumns = _a.isFlexibleColumns, classes = _a.classes, isLoading = _a.isLoading, cellProps = _a.cellProps;
    var value = (0, react_1.useMemo)(function () { return ({
        translate: translate,
        isMobileHeader: isMobileHeader,
        isMobileBody: isMobileBody,
        filter: filter,
        title: title,
        actionsElement: actionsElement,
        onSaveColumnsSettings: onSaveColumnsSettings,
        isColumnSettings: isColumnSettings,
        isFlexibleColumns: isFlexibleColumns,
        classes: classes,
        isLoading: isLoading,
        cellProps: cellProps
    }); }, [
        translate,
        isMobileHeader,
        isMobileBody,
        filter,
        title,
        actionsElement,
        onSaveColumnsSettings,
        isColumnSettings,
        isFlexibleColumns,
        classes,
        isLoading,
        cellProps
    ]);
    return (react_1.default.createElement(exports.PropsContext.Provider, { value: value }, children));
};
exports.default = PropsProvider;
